// manually require fetch to avoid jest issues with node-fetch
const fetch = require('isomorphic-fetch');

export const cacheResponse = (cache, endPoint) => (response) => Promise.resolve((cache[endPoint] = response));

export const checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        const error = new Error(response.statusText);
        throw error;
    }
};

export const parseJSON = (response) => response.json();

export const fetchJSON = (...fetchConfig) =>
    fetch.apply(null, fetchConfig).then(checkStatus).then(parseJSON);

export const createCacheableFetch = (cache = Object.create(null)) => (fetchConfig) =>
    cache[fetchConfig[0]]
        ? Promise.resolve(cache[fetchConfig[0]])
        : fetchJSON(...fetchConfig).then(cacheResponse(cache, fetchConfig[0]));



// WEBPACK FOOTER //
// ./src/helpers/fetchTools.ts